import { messaging } from 'lib/axios';
import { useQuery } from 'react-query';

export const getConversations = () => {
  const data = messaging.get('/conversations');

  return data;
};

export const useConversations = ({ config } = {}) => {
  return useQuery({
    ...config,
    queryKey: ['conversations'],
    queryFn: () => getConversations(),
  });
};
